import { useIsMediaQuery } from "@/shared/hooks";
import { Box, Grid, SxProps, Theme } from "@mui/material";

export type CustomTabPanelProps = {
  children: React.ReactNode;
  index: number | string;
  value: number | string;

  sxBox?: SxProps<Theme>;
  justifyContent?: string;
};

const CustomTabPanel: React.FC<CustomTabPanelProps> = ({
  children,
  value,
  index,
  sxBox = { padding: "0px 10px 0px", minWidth: "100%" },
  justifyContent = "center",
}) => {
  const isMobile = useIsMediaQuery("sm");

  if (value !== index) return null;

  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ width: "100%" }}
    >
      <Box sx={isMobile ? { padding: "20px 0px", minWidth: "100%" } : sxBox}>
        <Grid item container spacing={2} justifyContent={justifyContent}>
          {children}
        </Grid>
      </Box>
    </div>
  );
};

export default CustomTabPanel;
